export default {
  date: 'DD/MMM/YYYY',
  dateTime: 'DD/MMM/YYYY HH:mm',
  inputDate: 'YYYY-MM-DD',
  inputDateTime: 'YYYY-MM-DD HH:mm:ss',
};
